import React, {useState} from "react";
import {useAppSelector} from "../../../../redux/hooks";
import stocksService from "../../../../api/services/stocksService";
import { ReactComponent as ArrowDownCircleFilledIcon } from '../../../../assets/icons/new/UI/ArrowDownCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';

// @ts-ignore
function DownloadStocksAsXlsx({label, toCloseModalMenu, isExportOnlyEditable, isExportOnlyFBO}) {

    label = label || 'Отчет'

    const { sellerId, userId } = useAppSelector(({ sellers, users }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
        userId: users.currentUser.data.id
    }))

    const [inProcessing, setInProcessing] = useState<boolean>(false)

    function clickHandler() {
        setInProcessing(true)
        if (!sellerId || !userId) {
            setInProcessing(false)
            return;
        }
        stocksService.getStocksAsXlsx(sellerId, userId, isExportOnlyEditable, isExportOnlyFBO)
            .then(
                (res) => {
                    if (res.data.success) {
                        downloadFile(res.data.data, sellerId)
                    }
                },
                (err) => {
                    alert('Failed getting xlsx data: ' + err.message)
                }
            )
            .catch((err) => {
                alert('Failed getting xlsx data: ' + err.message)
            })
            .finally(() => setInProcessing(false))
    }

    function downloadFile(base64Data: string, sellerId: number) {
        const mediaType = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";

        const href = mediaType + base64Data

        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.setAttribute('href', href);
        const date = (new Date()).toISOString().split('T')[0].replaceAll('-', '')
        link.setAttribute('download', `${sellerId}-stocks-${date}.xlsx`);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link)
        }, 500)
    }

    function clickHandlers() {
        clickHandler();
        if (toCloseModalMenu) {
            toCloseModalMenu();
        }
    }

    return (
        <PillActionButton
            icon={ArrowDownCircleFilledIcon}
            label={label}
            onClick={clickHandlers}
            loading={inProcessing}
        />
    );
}

export default DownloadStocksAsXlsx;
